import React from "react"
import { Container, Row, Col, Form } from "react-bootstrap"
import useForm from "../useForm"
import {
  dobDayOptions,
  dobMonthOptions,
  dobYearOptions,
} from "../../data/formOptions"

const MultiDOB = props => {
  const { values, handleChange: formHandleChange, addValidationError, removeValidationError } = props


  const handleBlur = e => {
    handleChange(e)
  }

  const handleChange = e => {
    formHandleChange(e)
    if (isValid(e)) {
      removeValidationError(e.target.name)
    }
  }

  const isValid = e => {
    const { name, value } = e.target
    if (name === "dobDay" && value === "Day") {
      addValidationError("Day required", name)
      return false
    }
    if (name === "dobMonth" && value === "Month") {
      addValidationError("Month required", name)
      return false
    }
    if (name === "dobYear" && value === "Year") {
      addValidationError("Year required", name)
      return false
    }
    
    return true
  }

  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col>
            {/* <Form autoComplete="on"> */}
              <Form.Row className="dob">
                <Form.Group as={Col} controlId="dobDay" sm={4}>
                  <div className="row-question">
                    <Form.Label>Date of birth</Form.Label>
                    <Form.Control
                      as="select"
                      name="dobDay"
                      value={values.dobDay}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    >
                      {dobDayOptions.map(({ value, formattedValue }) => (
                        <option key={value} value={value}>
                          {formattedValue}
                        </option>
                      ))}
                    </Form.Control>
                  </div>
                </Form.Group>
                <Form.Group as={Col} controlId="dobMonth" sm={4}>
                  <div className="row-question">
                    <Form.Control
                      as="select"
                      name="dobMonth"
                      value={values.dobMonth}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    >
                      {dobMonthOptions.map(({ value, formattedValue }) => (
                        <option key={value} value={value}>
                          {formattedValue}
                        </option>
                      ))}
                    </Form.Control>
                  </div>
                </Form.Group>
                <Form.Group as={Col} controlId="dobYear" sm={4}>
                  <div className="row-question">
                    <Form.Control
                      as="select"
                      name="dobYear"
                      value={values.dobYear}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    >
                      {dobYearOptions.map(({ value, formattedValue }) => (
                        <option key={value} value={value}>
                          {formattedValue}
                        </option>
                      ))}
                    </Form.Control>
                  </div>
                </Form.Group>
              </Form.Row>
            {/* </Form> */}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default MultiDOB
